module.exports = __webpack_public_path__ + "static/media/switch-buddy.0b7a8b2e.png";